export function slugToParams(slug: string): {
    category_slug: string;
    hash: string;
    title: string;
} {
    const parts = slug.split("/");
    return {
        category_slug: parts[0],
        hash: parts[1],
        title: parts[2],
    };
}

export function productSlugToArray(slug: string): [string, string, string] {
    const ret = slug.split("/");
    if (ret.length !== 3) {
        throw new Error("Expected product slug to have 3 parts");
    }
    return ret as [string, string, string];
}
